import {
  CaretLeftFilled,
  CaretRightFilled,
  CloudDownloadOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import API from "@src/api/backend/officeDetail";
import { lang } from "@src/constants/common.const";
import { ReactComponent as DeleteIcon } from "@src/styles/icon/delete.svg";
import { ReactComponent as EditIcon } from "@src/styles/icon/edit.svg";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Menu,
  Modal,
  Row,
  Select,
  Tooltip,
} from "antd";
import ExcelJS from "exceljs";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { COMMON_CONSTANT, KEY } from "../../constants/common.const";
import {
  downloadChartItemImage,
  handleDataChartHelper,
  MSG_CATCH,
  showMessage,
} from "../../constants/utils";
import { exportSingleDynamicchart } from "../../utils/exportPdf";
import { chartLine } from "./chart.options";
import "./index.scss";

function OverlapChart({
  isPreUseChecklist,
  item,
  index,
  removeItem,
  updateItem,
  isPopup,
  setLoadingDelete,
  disabledEdit = false,
  orderNumber,
  onChangeOrder,
  dataChartsLength,
  isEndUser,
  isDynamicScreen,
}) {
  const getYAxis = (x) => {
    const isCustomMinMax = +x.min || +x.max;
    const objMinMax = isCustomMinMax ? { min: +x.min, max: +x.max } : {};
    const plotLinesOption = {
      value: "",
      label: {
        text: "",
        align: "right",
        style: {
          color: "red",
        },
        x: -10,
      },
      color: "red",
      width: 2,
      dashStyle: "dash",
    };

    return {
      ...objMinMax,
      tickPixelInterval: 40,
      scrollablePlotArea: {
        minHeight: 100,
        maxHeight: 200,
      },
      title: {
        text: "",
        style: {
          color: x.color,
        },
      },
      labels: {
        overflow: "allow",
        padding: 1,
        allowOverlap: true,
        style: {
          color: "#000000D9",
          fontSize: 10,
        },
      },
      plotLines: showThreshold
        ? [
            {
              ...plotLinesOption,
              value: x.normalLowerControlValue,
              label: {
                ...plotLinesOption.label,
                text: "下限値: " + x.normalLowerControlValue,
                align: "left",
              },
            },
            {
              ...plotLinesOption,
              value: x.normalUpperControlValue,
              label: {
                ...plotLinesOption.label,
                text: "上限値: " + x.normalUpperControlValue,
              },
            },
          ]
        : [],
    };
  };
  const handleMouseOver = (e) => {
    setShowThreshold(true);
  };
  const handleMouseOut = () => {
    setShowThreshold(false);
  };

  const linkYaxis = (x, i, item) => ({
    ...x,
    // yAxis: item.length - i - 1,
    events: {
      mouseOver: handleMouseOver,
      mouseOut: handleMouseOut,
    },
  });
  const handleOptionDownload = (e) => {
    if (e.key === "PDF") {
      handleDownloadPdf();
    } else if (e.key === "Excel") {
      handleDownloadExcel();
    }
  };

  const optionDownload = (
    <Menu onClick={handleOptionDownload}>
      <Menu.Item key="PDF">{lang.DOWNLOAD_PDF}</Menu.Item>
      <Menu.Item key="Excel">{lang.DOWNLOAD_EXCEL}</Menu.Item>
    </Menu>
  );
  const [triggerChart, setTriggerChart] = useState(false);

  const [type, updateType] = useState(item.type);
  const [data, updateData] = useState(item);
  const [options, updateOptions] = useState(null);
  const [disableWhenLoading, updateDisableRadio] = useState(false);
  let [currentIndex, updateIndex] = useState(0);
  const history = useHistory();
  const defaultType = item.type || 1;
  const [showThreshold, setShowThreshold] = useState(false);
  const [startDateReport, setStartDateReport] = useState(
    moment(data.labels[0])
  );
  const [endDateReport, setEndDateReport] = useState(
    moment(data.labels[data.labels.length - 1])
  );
  const [fiscalYear, setFiscalYear] = useState(moment());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [listMonths, setlistMonths] = useState([]);
  const [disabledCheckMonth, setDisabledCheckMonth] = useState(false);
  const [itemName, setItemName] = useState("");

  // data year
  const [allDataCurrentYear, setAllDataCurrentYear] = useState(null);
  // handle series
  let listSeries = useRef([]);
  let baseDataChart = useRef({});
  const colors = useRef([
    "#154c79",
    "#154c79",
    "#FF4500",
    "#FFD700",
    "#F4A300",
    "#1E90FF",
    "#00BFFF",
    "#4682B4",
    "#32CD32",
    "#8A2BE2",
    "#00FA9A",
    "#ADD8E6",
    "#21130d",
  ]);

  // Data of year
  const dataOfYear = useRef();
  const labelsDataOfYear = useRef();
  const getAllData = async () => {
    try {
      // data of year
      setDisabledCheckMonth(true);

      await getDataOfYear(currentYear);

      setDisabledCheckMonth(false);
    } catch (error) {
    }
  };
  // get All Data
  useEffect(() => {
    if (currentYear) {
      getAllData();
    }
  }, [currentYear]);

  useEffect(() => {
    updateData(item);
    if (!itemName) {
      const name =
        Array.isArray(item.series) && item.series.length > 0
          ? item.series[0].name
          : "";
      const unit =
        Array.isArray(item.series) && item.series.length > 0
          ? item.series[0].unit
          : "";

      setItemName(`${name} (${unit})`);
    }
    const newChartLine = JSON.parse(JSON.stringify(chartLine));
    updateOptions({
      ...newChartLine,
      chart: {
        scrollablePlotArea: {
          minWidth: 800,
          scrollPositionX: 1,
        },
      },
      series: [...item.series.map(linkYaxis)],

      xAxis: {
        ...chartLine.xAxis,
        categories: item.categories,
        labels: {
          step: 1,
          rotation: -30,
          y: 30,
        },
      },
      yAxis: [...item.series.slice(0, 1)].reverse().map(getYAxis),

      legend: {
        enabled: true,
        useHTML: true,
        labelFormatter: function () {
          return `<span title="${this.userOptions.month + "月"}">${
            this.userOptions.month + "月"
          }</span>`;
        },
      },
    });
  }, [item, showThreshold]);

  const handleDataChart = (itemUpdate, typeChange = type, month) => {
    const itemUpdated = itemUpdate.data[0];
    const dataChart = itemUpdated.data;
    const arrLabels = [];
    const exactLabels = [];
    const arrData = [];
    let hasDataLabel = false;
    dataChart.forEach((line) => {
      // handle line data
      const arrLineValue = [];
      let hasDataValue = false;
      if (line.data.length) {
        const dataLine = line.data;
        dataLine.forEach((itemDayOfLine) => {
          if (!hasDataLabel) {
            let label;
            if (itemDayOfLine.groupTitle && Number(typeChange) !== 2) {
              label = itemDayOfLine.groupTitle;
            } else {
              label = itemDayOfLine.title || "";
            }
            arrLabels.push(label);
            exactLabels.push(itemDayOfLine.title || "");
          }
          if (itemDayOfLine.value !== null) {
            hasDataValue = true;
          }
          const finalValue =
            itemDayOfLine.value == 0 ? 0 : Number(itemDayOfLine.value) || null;
          arrLineValue.push(finalValue);
        });
        hasDataLabel = true;
      }
      const lineData = {
        name: month + "月",
        nameItem: line.checkItemName,
        data: hasDataValue ? arrLineValue : [],
        machineName: line.machineForSiteOfficeName || "",
        color: colors.current[month],
        unit: line.unit,
        min: line.min,
        max: line.max,
        normalLowerControlValue: line.normalLowerControlValue,
        normalUpperControlValue: line.normalUpperControlValue,
        month,
      };
      arrData.push(lineData);
    });
    let stringCheckItemName = arrData.map((item) => item.name).join(",");
    if (itemUpdated.data[0] && itemUpdated.data[0].checkItemName) {
      stringCheckItemName = itemUpdated.data[0].checkItemName;
    }
    let machineForSiteOfficeName = "";
    if (itemUpdated.data[0] && itemUpdated.data[0].machineForSiteOfficeName) {
      machineForSiteOfficeName = itemUpdated.data[0].checkItemName;
    }

    // get Category
    let maxDay = 28;
    listMonths.forEach((month) => {
      const days = getDaysInMonth(month, currentYear);
      if (days > maxDay) {
        maxDay = days;
      }
    });
    const categories = Array.from({ length: maxDay }, (_, i) => i + 1 + "");
    const dataItem = {
      id: itemUpdated.id,
      itemCode: itemUpdated.checkItemCode || item.itemCode,
      checkItemName: stringCheckItemName,
      labels: categories,
      type: itemUpdated.type,
      machineName: machineForSiteOfficeName || "",
      normalLowerControlValue: itemUpdated.normalLowerControlValue,
      normalUpperControlValue: itemUpdated.normalUpperControlValue,
      min: itemUpdate.min,
      max: itemUpdate.max,
      unit: itemUpdated.unit,
      series: arrData,
      categories,
      reportName: itemUpdated.name,
      checklistType: itemUpdated.checklistType,
      exactLabels,
      dataOfYear: dataOfYear.current || [],
      labelsDataOfYear: labelsDataOfYear.current || [],
    };

    baseDataChart.current = dataItem;
    listSeries.current.push(arrData[0]);
  };

  function getDaysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  function formatDateStartDayAndLastDay(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  }

  function getStartAndLastDay(year, month) {
    const startDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);

    return {
      startDay: formatDateStartDayAndLastDay(startDay),
      lastDay: formatDateStartDayAndLastDay(lastDay),
    };
  }

  const updateItemWithDataOfYear = (data) => {
    updateItem({
      ...data,
      dataOfYear: dataOfYear.current || [],
      labelsDataOfYear: labelsDataOfYear.current || [],
    });
  };
  // get data chart by list
  const getDataDynamicChartByCheckbox = async () => {
    try {
      listSeries.current = [];
      if (listMonths.length === 0) {
        updateOptions({ ...options, series: [] });
        updateItemWithDataOfYear({ ...item, isHasData: false });
      } else {
        const listRes = [];
        listMonths.forEach((month) => {
          const dataRes = JSON.parse(JSON.stringify(allDataCurrentYear));
          const dataArr = Array.isArray(dataRes.data) ? dataRes.data[0] : {};
          const listAllData = dataArr.data[0].data;
          const listDataOfMonth = listAllData.filter((item) => {
            const date = new Date(item.title);
            const curentMonth = date.getMonth() + 1;
            return Number(curentMonth) == month;
          });
          dataRes.data[0].data[0].data = listDataOfMonth;

          listRes.push(dataRes);
        });

        listRes.forEach((res, index) => {
          handleDataChart(res, null, listMonths[index]);
        });

        const listSeriesHaveData = listSeries.current.filter(
          (item) => item.data.length > 0
        );
        baseDataChart.current = {
          ...baseDataChart.current,
          series: listSeries.current,
          isHasData: listSeriesHaveData.length > 0,
        };

        // check have Data
        updateItemWithDataOfYear(baseDataChart.current);
      }
    } catch (error) {
    } finally {
    }
  };
  useEffect(() => {
    getDataDynamicChartByCheckbox();
  }, [currentYear, listMonths, allDataCurrentYear]);

  // Trigger chart
  useEffect(() => {
    setTriggerChart(!triggerChart);
  }, [listMonths, currentYear]);
  // get data of year

  const getDataOfYear = async (year) => {
    const startOfYear = moment(`${year}-01-01`).format("YYYY/MM/DD");
    const endOfYear = moment(`${year}-12-31`).format("YYYY/MM/DD");
    const res = await API.getDataItemChartByType(
      data.itemCode,
      data.id,
      1,
      true,
      null,
      startOfYear,
      endOfYear
    );
    const item = handleDataChartHelper(res);
    dataOfYear.current = item.series;
    labelsDataOfYear.current = item.labels;
    setAllDataCurrentYear(res);
  };

  const deleteChart = (id) => {
    async function handleDelete() {
      setLoadingDelete && setLoadingDelete(true);
      API.deleteChart(id)
        .then((res) => {
          if (res.status === 200) {
            removeItem(id);
            showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
          }
        })
        .catch((err) => {
          showMessage(KEY.ERROR, MSG_CATCH());
        })
        .finally(() => setLoadingDelete && setLoadingDelete(false));
    }

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      title: lang.DELETE,
      content: COMMON_CONSTANT.BOM_C001,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: handleDelete,
      centered: true,
    });
  };
  const editReport = (id) => {
    history.push(`/DynamicReportManagement/edit/${id}`);
  };
  const clickBack = () => {
    const ind = currentIndex + 1;
    updateIndex(ind);
    setStartDateReport(moment(data.labels[0]));
    setEndDateReport(moment(data.labels[data.labels.length - 1]));
    setCurrentYear(currentYear - 1);
  };
  const clickNext = () => {
    const ind = currentIndex - 1;
    updateIndex(ind);
    setStartDateReport(moment(data.labels[0]));
    setEndDateReport(moment(data.labels[data.labels.length - 1]));
    setCurrentYear(currentYear + 1);
  };

  const transTextEllipsis = (text, skip = 30) => {
    if (text && text.length) {
      let newText = "";
      for (let i = 0; i < text.length; i++) {
        if (i < skip) {
          newText += text[i];
        } else {
          newText += " ...";
          break;
        }
      }
      return newText;
    } else {
      return null;
    }
  };

  const onChangeCheckBox = (month) => {
    if (listMonths.includes(month)) {
      setlistMonths(listMonths.filter((i) => i != month).sort((a,b) => a-b));
    } else {
      setlistMonths([...listMonths, month].sort((a,b) => a-b));
    }
  };

  const handleDownloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    try {
      const itemDownload = {
        ...item,
        dataOfYear: dataOfYear.current || [],
        labelsDataOfYear: labelsDataOfYear.current || [],
      };
      await downloadChartItemImage(
        workbook,
        itemDownload,
        `chart-${index}`,
        index
      );
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `動的レポート - ${item.reportName}.xlsx`;
      link.click();
    } catch (error) {}
  };

  const handleDownloadPdf = async () => {
    exportSingleDynamicchart(`chart-${index}`, data.reportName);
  };
  return (
    <Row
      key={index + item.id}
      className="rowNotMargin chart dynamic-report"
      gutter={[24, 32]}
      style={{
        position: "relative",
      }}
    >
      <Col span={24} className="mb8" style={{ padding: "4px" }}>
        <Row
          className="rowNotMargin"
          justify="space-between"
          align="middle"
          gutter={[0, 8]}
        >
          <Col>
            {orderNumber && !disabledEdit && (
              <Select
                style={{
                  height: "32px",
                  marginRight: 4,
                  fontSize: "14px",
                  verticalAlign: "bottom",
                }}
                onChange={onChangeOrder}
                value={orderNumber}
              >
                {[...Array(dataChartsLength)].map((_, i) => (
                  <Select.Option key={i + 1}>{i + 1}</Select.Option>
                ))}
              </Select>
            )}
          </Col>
          <Col className="title text-center">
            {isPopup ? (
              <>
                <span style={{ fontWeight: "normal" }}>機器：</span>
                <span style={{ fontWeight: "bold" }}>
                  <Tooltip title={data.machineName} zIndex="100000">
                    {transTextEllipsis(data.machineName)}
                  </Tooltip>
                </span>
                <span style={{ fontWeight: "normal" }}> ー 項目：</span>
                <span style={{ fontWeight: "bold" }}>{data.checkItemName}</span>
              </>
            ) : (
              <>
                <div>
                  <span style={{ fontWeight: "normal" }}>{lang.REPORT}：</span>
                  <span style={{ fontWeight: "bold" }}>
                    <Tooltip title={data.reportName} zIndex="100000">
                      {transTextEllipsis(data.reportName)}
                    </Tooltip>
                  </span>
                </div>
                <div style={{ fontSize: isDynamicScreen ? 16 : 14 }}>
                  <span style={{ fontWeight: "normal" }}>
                    {lang.INSPECTION_TIME_NAME}：
                  </span>
                  <span style={{ fontWeight: "bold" }}>
                    <Tooltip title={data.itemName} zIndex="100000">
                      {transTextEllipsis(itemName)}
                    </Tooltip>
                  </span>
                </div>
              </>
            )}

            {/* {renderRangeValue(data)} */}
          </Col>
          {isPopup ? (
            <></>
          ) : (
            <Row className="nowrap" gutter={[16, 0]} align="middle">
              {!disabledEdit && (
                <Col>
                  <Button
                    type="link"
                    className="iconAction-edit btnLink"
                    onClick={(e) => {
                      editReport(data.id);
                      e.preventDefault();
                    }}
                  >
                    <EditIcon />
                  </Button>
                </Col>
              )}
              {!disabledEdit && (
                <Col>
                  <Button
                    type="link"
                    className="iconAction-edit btnLink"
                    onClick={(e) => {
                      deleteChart(data.id);
                      e.preventDefault();
                    }}
                  >
                    <DeleteIcon />
                  </Button>
                </Col>
              )}
              {isDynamicScreen && (
                <>
                  <Col>
                    <Dropdown overlay={optionDownload}>
                      <Button type="link" className="iconAction-edit btnLink">
                        <CloudDownloadOutlined style={{ marginTop: 5 }} />
                      </Button>
                    </Dropdown>
                  </Col>
                </>
              )}
            </Row>
          )}
        </Row>
      </Col>

      <Col span={3} className="p4 left">
        <Row className="p0" style={{ maxHeight: 420, overflow: "auto" }}>
          {Array.from({ length: 12 }, (_, i) => i + 1).map((item, index) => {
            return (
              <Col span={24}>
                <Checkbox
                  disabled={disabledCheckMonth}
                  checked={listMonths.includes(item)}
                  onChange={() => onChangeCheckBox(item)}
                  key={index}
                  value={item}
                >
                  <Tooltip title={item}>{item + "月"}</Tooltip>
                </Checkbox>
              </Col>
            );
          })}
        </Row>
      </Col>
      <Col
        style={
          !item.isHasData || listMonths.length === 0
            ? {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",

                transform:
                  (!item.isHasData || listMonths.length === 0) &&
                  "translateX(-50px)",
              }
            : {}
        }
        span={21}
        className="text-center p4"
      >
        <div></div>
        {(!item.isHasData || listMonths.length == 0) && (
          <>
            <div span={24} className="p4 text-center">
              <p>データがありません。</p>
            </div>
          </>
        )}
        {item.isHasData && listMonths.length > 0 && (
          <HighchartsReact
            key={triggerChart}
            highcharts={Highcharts}
            options={options}
          />
        )}
        {!isPopup && (
          <div className="mt8 overlap-currentYear">
            <Button
              disabled={currentYear <= 0 || disabledCheckMonth}
              style={{ minWidth: "unset" }}
              type="text"
              onClick={() => clickBack()}
              icon={
                <CaretLeftFilled
                  style={{ fontSize: "20px", paddingRight: "10px" }}
                />
              }
            />
            {currentYear}
            <Button
              style={{ minWidth: "unset" }}
              type="text"
              onClick={() => clickNext()}
              disabled={
                currentYear === new Date().getFullYear() || disabledCheckMonth
              }
              icon={
                <CaretRightFilled
                  style={{ fontSize: "20px", paddingLeft: "10px" }}
                />
              }
            />
          </div>
        )}
      </Col>
    </Row>
  );
}

export default OverlapChart;
